'use strict';

var React = require('react');

var TextInput          = require('js/screens/form/input/text.jsx'),
    TextAreaInput      = require('js/screens/form/input/textarea.jsx'),
    UniDropdownInput   = require('js/screens/form/input/unidropdown.jsx'),
    DropdownInput      = require('js/screens/form/input/dropdown.jsx'),
    CheckboxInput      = require('js/screens/form/input/checkbox.jsx'),
    RadiobuttonInput   = require('js/screens/form/input/radiobutton.jsx'),
    classnames         = require('classnames');

var TYPES = require('js/shared/utils/input-types.js').TYPES;

var QuestionInput = React.createClass({

  propTypes: {
    type: React.PropTypes.number.isRequired,
    title: React.PropTypes.string.isRequired,
    subtitle: React.PropTypes.string,
    fieldName: React.PropTypes.string.isRequired,

    // list types
    list: React.PropTypes.arrayOf(React.PropTypes.string),

    // anything that can continue via. a trigger, like hitting Enter
    nextCallback: React.PropTypes.func,

    // existing value state
    value: React.PropTypes.any,
    hasError: React.PropTypes.bool
  },

  render: function() {
    var type = this.props.type;

    var questionInput = null;
    if (type === TYPES.TEXT) {
      questionInput = <TextInput autoFocus={!this.props.onReview} {...this.props} />;
    } else if (type === TYPES.TEXTAREA) {
      questionInput = <TextAreaInput autoFocus={!this.props.onReview} {...this.props} />;
    } else if (type === TYPES.UNIDROPDOWN) {
      questionInput = <UniDropdownInput autoFocus={!this.props.onReview} {...this.props} />;
    } else if (type === TYPES.DROPDOWN) {
      questionInput = <DropdownInput autoFocus={!this.props.onReview} {...this.props} />;
    } else if (type === TYPES.CHECKBOX) {
      questionInput = <CheckboxInput {...this.props} />;
    } else if (type === TYPES.RADIOBUTTON) {
      questionInput = <RadiobuttonInput {...this.props} />;
    } else if (type === TYPES.PASSWORD) {
      questionInput = <TextInput textFieldType="password" autoFocus={!this.props.onReview} {...this.props} />;
    } else if (type === TYPES.NUMBER) {
      questionInput = <TextInput textFieldType="number" autoFocus={!this.props.onReview} {...this.props} />;
    }


    var classes = classnames({
      'QuestionInput': true,
      'QuestionInput--review': this.props.onReview,
      'QuestionInput--placeholder': !this.props.onReview && this.props.subtitle
    });

    return (
      <div className={classes}>
        {questionInput}
      </div>
    );
  }
});

module.exports = QuestionInput;



/** WEBPACK FOOTER **
 ** ./js/screens/form/application-question-input.jsx
 **/